
















































import { Component, Prop, PropSync, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { SortOrder } from '@/types'
import { SystemCode } from '@/api'
import { orderBy } from 'lodash'

export interface BibliographyIntegrationDataTableItem {
  isSelected: boolean
  collectionId: number
  collectionNo: string
  holdingBranchCode: SystemCode
  status: SystemCode
  callNo: string
  revision: number
}

@Component({
  components: { DataTable }
})
export default class BibliographyIntegrationDataTable extends ComponentVue {
  @Prop({
    type: Boolean,
    default: false
  })
  isCheck!: boolean

  @PropSync('items', {
    type: Array,
    required: true
  })
  tableItems!: BibliographyIntegrationDataTableItem[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  disabledAllSelect!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isAllSelect!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  // 定数管理だと同じ画面に複数同じテーブルを使用する時、参照が同一となる事が問題
  // 例えばsort処理のクリックで両方のアイコンが変換される等おかしい挙動になる、その為、変数管理とする
  cols: Col[] = [
    {
      width: 26,
      items: [
        {
          name: 'check',
          align: 'center'
        }
      ]
    },
    {
      width: 50,
      items: [
        {
          name: 'no',
          align: 'right'
        }
      ]
    },
    {
      width: '25',
      resizable: true,
      items: [
        {
          name: 'collectionNo',
          headerText: '資料番号',
          sortable: true,
          sortOrder: ''
        }
      ]
    },
    {
      width: '20',
      resizable: true,
      items: [
        {
          name: 'holdingBranchCode',
          headerText: '所蔵館',
          sortable: true,
          sortOrder: ''
        }
      ]
    },
    {
      width: '20',
      resizable: true,
      items: [
        {
          name: 'status',
          headerText: '資料状態',
          sortable: true,
          sortOrder: ''
        }
      ]
    },
    {
      width: '35',
      resizable: true,
      items: [
        {
          name: 'callNo',
          headerText: '請求記号',
          sortable: true,
          sortOrder: ''
        }
      ]
    }
  ]

  get showCols(): Col[] {
    if (this.isCheck) {
      return this.cols
    }

    return this.cols.filter(col => col.items[0].name !== 'check')
  }

  get sortedItems(): BibliographyIntegrationDataTableItem[] {
    if (this.sortName) {
      return orderBy<BibliographyIntegrationDataTableItem>(
        this.tableItems,
        (item: BibliographyIntegrationDataTableItem) => {
          const propertyValue =
            item[this.sortName as keyof BibliographyIntegrationDataTableItem]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.tableItems
  }

  mounted(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onRowClick(index: number): void {
    const targetIndex: number = this.tableItems.findIndex(
      value => value.collectionId === this.sortedItems[index].collectionId
    )

    if (~targetIndex) {
      this.tableItems[targetIndex].isSelected = !this.tableItems[targetIndex]
        .isSelected
    }
  }

  @Emit('all-select')
  onAllSelect(value: boolean): boolean {
    return value
  }
}
